/**
 * @module features/devices/api/useDeviceDetail
 * @description Query hook for one device (includes firmware history).
 */
import { useQuery } from "@tanstack/react-query";
import { deviceKeys, getDevice } from "./devices-api";

export function useDeviceDetail(id: string | null | undefined) {
  return useQuery({
    queryKey: deviceKeys.detail(id ?? ""),
    queryFn: () => getDevice(id as string),
    enabled: Boolean(id),
  });
}
